import type { TranslationKey } from './translations';

export const mainNav: { to: string; key: TranslationKey }[] = [
  { to: '/', key: 'nav.home' },
  { to: '/m1-pro', key: 'nav.m1pro' },
  { to: '/systems', key: 'nav.systems' },
  { to: '/magnetic-mount', key: 'nav.mount' },
  { to: '/engineering', key: 'nav.engineering' },
  { to: '/applications', key: 'nav.applications' },
  { to: '/support', key: 'nav.support' },
];

// Hamburger drawer navigation (order approved by owner).
export const drawerNav: { to: string; key: TranslationKey }[] = [
  { to: '/', key: 'nav.home' },
  { to: '/m1-pro', key: 'nav.m1pro' },
  { to: '/systems', key: 'nav.lighting' },
  { to: '/magnetic-mount', key: 'nav.magnetic' },
  { to: '/engineering', key: 'nav.engineering' },
  { to: '/support', key: 'nav.support' },
  { to: '/applications', key: 'nav.applications' },
];

export const footerGroups: { title: string; links: { to: string; label: string }[] }[] = [
  {
    title: 'Products',
    links: [
      { to: '/m1-pro', label: 'M1 PRO' },
      { to: '/build', label: 'Build Your Own System' },
      { to: '/systems', label: 'Complete Lighting Systems' },
      { to: '/magnetic-mount', label: 'Magnetic Mount System' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/engineering', label: 'Engineering & Development' },
      { to: '/applications', label: 'Applications' },
      { to: '/promise', label: 'The MarineForce Promise' },
    ],
  },
  {
    title: 'Support',
    links: [
      { to: '/support', label: 'Contact & Support' },
      { to: '/faq', label: 'FAQ' },
      { to: '/warranty-claim', label: 'Warranty Claim' },
      { to: '/order-tracking', label: 'Order Tracking' },
    ],
  },
  {
    title: 'Policies',
    links: [
      { to: '/warranty', label: 'Warranty Information' },
      { to: '/shipping', label: 'Shipping Policy' },
      { to: '/returns', label: 'Return & Refund Policy' },
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Service' },
      { to: '/safety', label: 'Product Safety & Use' },
      { to: '/accessibility', label: 'Accessibility' },
      { to: '/contact-information', label: 'Contact Information' },
      { to: '/legal-notice', label: 'Legal Notice' },
    ],
  },
];
